import { render, staticRenderFns } from "./messageview.vue?vue&type=template&id=be842168&"
import script from "./messageview.vue?vue&type=script&lang=ts&"
export * from "./messageview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be842168')) {
      api.createRecord('be842168', component.options)
    } else {
      api.reload('be842168', component.options)
    }
    module.hot.accept("./messageview.vue?vue&type=template&id=be842168&", function () {
      api.rerender('be842168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messageview.vue"
export default component.exports